import React from 'react';
import { BasicTooltip } from '@livable/saas-react-components';
import { Typography } from '@mui/material';
import RippleEffect from 'src/components/general/RippleEffect';
import useStyles from '../styles';
export default function UnitCell(_ref) {
  let params = _ref.params;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.overflowCellWrapper, " ").concat(classes.cellLeftAlign)
  }, params.row.vacant && /*#__PURE__*/React.createElement(BasicTooltip, {
    title: params.row.Unitname,
    placement: "top",
    hideOnMobile: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.cellLeftAlign, " cellContent")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.overflowCell
  }, params.row.Unitname))), !params.row.vacant && /*#__PURE__*/React.createElement(BasicTooltip, {
    title: params.row.Unitname,
    placement: "top",
    hideOnMobile: true
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RippleEffect, {
    className: "".concat(classes.cellContent, " ").concat(classes.cellLeftAlign, " cellContent")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.overflowCell
  }, params.row.Unitname)))));
}